import { type NotificationsKind } from '@core/notifications';

export const NOTIFICATIONS_DEFAULT_TAB: NotificationsKind = 'notifications';

export interface NotificationsSkeletonRow {
  readonly lines: readonly string[];
}

export const NOTIFICATIONS_SKELETON: readonly NotificationsSkeletonRow[] = [
  { lines: ['w-3/5', 'w-4/5', 'w-1/4'] },
  { lines: ['w-1/2', 'w-2/3', 'w-1/3'] },
  { lines: ['w-3/5', 'w-3/4', 'w-1/5'] },
  { lines: ['w-1/2', 'w-2/3', 'w-2/5'] },
  { lines: ['w-[55%]', 'w-[70%]', 'w-[28%]'] },
  { lines: ['w-1/2', 'w-3/4', 'w-1/3'] },
];

export const NOTIFICATIONS_MESSAGE_SKELETON: readonly NotificationsSkeletonRow[] = [
  { lines: ['w-1/3', 'w-1/2', 'w-full', 'w-2/3'] },
  { lines: ['w-2/5', 'w-1/2', 'w-5/6', 'w-3/5'] },
  { lines: ['w-[30%]', 'w-1/2', 'w-full', 'w-1/2'] },
  { lines: ['w-2/5', 'w-1/2', 'w-full', 'w-3/5'] },
  { lines: ['w-1/3', 'w-1/2', 'w-5/6', 'w-2/3'] },
];

const MOBILE_SKELETON_FILL = 12;

export function fillMobileSkeleton(
  recipes: readonly NotificationsSkeletonRow[],
): readonly NotificationsSkeletonRow[] {
  return Array.from({ length: MOBILE_SKELETON_FILL }, (_, i) => recipes[i % recipes.length]);
}

/** Decorative until notifications unread counts exist. */
export const NOTIFICATIONS_HAS_UNREAD = {
  notifications: true,
  messages: true,
} as const;

export interface NotificationsCopy {
  readonly titleKey: string;
  readonly emptyTitleKey: string;
  readonly emptyDescriptionKey: string;
  readonly illustration: string;
}
